module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/062-namibia-8796471200491493b2d1fbf417356891.svg";